import type { UseSpringProps } from '@react-spring/web';
import { animated, useSpring } from '@react-spring/web';
import type { FormatNumberOptions } from 'react-intl';
import { useIntl } from 'react-intl';

type Props = {
  value?: number;
  animationProps?: UseSpringProps;
  disableAnimationOnFirstRender?: boolean;
  formatNumberProps?: FormatNumberOptions;
};
export const AnimatedNumber = ({
  value,
  animationProps,
  disableAnimationOnFirstRender,
  formatNumberProps,
}: Props) => {
  const { formatNumber } = useIntl();
  const { animatedValue } = useSpring<{ animatedValue: number }>({
    from: disableAnimationOnFirstRender
      ? undefined
      : {
          animatedValue: 0,
        },
    to: {
      animatedValue: value,
    },
    ...animationProps,
  });

  return (
    <animated.span>
      {animatedValue.to(x =>
        formatNumber(x, {
          maximumFractionDigits: 0,
          ...formatNumberProps,
        })
      )}
    </animated.span>
  );
};
